<!-- No banner here. The tab that hosts this list already carries one
     (`knowledge_base.info_banner.price_imports`), and the two said the same
     thing in two styles, stacked. -->
<div class="list-price-imports__table">
  <div class="list-price-imports__table-header">
    <div class="list-price-imports__table-cell">
      {{ "knowledge_base.price_observations.imports.col.file" | translate }}
    </div>
    <div class="list-price-imports__table-cell">
      {{ "knowledge_base.price_observations.imports.col.source_kind" | translate }}
    </div>
    <div class="list-price-imports__table-cell">
      {{ "knowledge_base.price_observations.imports.col.uploaded_at" | translate }}
    </div>
    <div class="list-price-imports__table-cell">
      {{ "knowledge_base.price_observations.imports.col.state" | translate }}
    </div>
    <!-- The scope chosen at import — why a file attributed everything to one
         customer stays answerable months later. -->
    <div class="list-price-imports__table-cell">
      {{ "knowledge_base.price_observations.imports.col.scope" | translate }}
    </div>
    <div class="list-price-imports__table-cell list-price-imports__table-cell--numeric">
      {{ "knowledge_base.price_observations.imports.col.created" | translate }}
    </div>
    <div class="list-price-imports__table-cell list-price-imports__table-cell--numeric">
      {{ "knowledge_base.price_observations.imports.col.to_verify" | translate }}
    </div>
    <div class="list-price-imports__table-cell list-price-imports__table-cell--numeric">
      {{ "knowledge_base.price_observations.imports.col.rejected" | translate }}
    </div>
    <!-- Sitting next to REJECTED, this header reads as "reasons for
         rejection". It is not: a line held for a human carries a reason too,
         and most rows here have 0 rejected and a reason. -->
    <div
      class="list-price-imports__table-cell"
      [matTooltip]="'knowledge_base.price_observations.imports.col.reasons_tooltip' | translate"
      matTooltipPosition="above"
    >
      {{ "knowledge_base.price_observations.imports.col.reasons" | translate }}
    </div>
  </div>

  <div class="list-price-imports__table-body">
    <div
      *ngFor="let item of rows; trackBy: trackById"
      class="list-price-imports__table-row"
      [class.is-failed]="item.state === 'failed'"
      [class.is-empty-result]="producedNothing(item)"
      (click)="onRowClick(item)"
    >
      <div class="list-price-imports__table-cell">
        <!-- The NAME is text and the eye opens it, the app's own preview
             affordance. No eye for an archive — there is no preview of a zip,
             only a download.
             The filename tooltip sits on the NAME, not on the cell: on the
             cell it also covered the button inside it, so hovering the eye
             showed two labels at once — the file name and "Preview". -->
        <span class="list-price-imports__filename" [matTooltip]="item.filename" matTooltipPosition="above">
          {{ item.filename }}
        </span>
        <button
          type="button"
          class="preview-icon"
          *ngIf="item.document_id"
          [matTooltip]="'common.preview' | translate"
          matTooltipPosition="above"
          [attr.aria-label]="'common.preview' | translate"
          (click)="openDocument(item); $event.stopPropagation()"
        >
          <ui-svg-icon svgIcon="eye" size="small"></ui-svg-icon>
        </button>
      </div>
      <div class="list-price-imports__table-cell">{{ sourceKindLabel(item) }}</div>
      <div class="list-price-imports__table-cell">
        {{ item.create_date ? (item.create_date | adaptToUserUtcOffset | date: DATE_TIME_FORMAT) : "--" }}
      </div>
      <div class="list-price-imports__table-cell">
        <ui-status-badge [label]="stateLabel(item)" [tone]="stateTone(item)"></ui-status-badge>
        <mat-icon *ngIf="isRunning(item)" class="list-price-imports__spinner">autorenew</mat-icon>
        <!-- The state is a question, so the row carries its answer. Without
             the button the operator reads "awaiting mapping" with nowhere to
             go, which is the silent dead end this journal exists to remove. -->
        <ui-button
          type="primary-text-outlined"
          class="list-price-imports__mapping-action"
          *ngIf="needsMapping(item)"
          [label]="'knowledge_base.price_observations.imports.map_columns' | translate"
          (click)="openMapping(item); $event.stopPropagation()"
        ></ui-button>
      </div>
      <div class="list-price-imports__table-cell">{{ scopeLabel(item) }}</div>
      <div class="list-price-imports__table-cell list-price-imports__table-cell--numeric">{{ item.count_created }}</div>
      <div class="list-price-imports__table-cell list-price-imports__table-cell--numeric">{{ item.count_to_verify }}</div>
      <div class="list-price-imports__table-cell list-price-imports__table-cell--numeric">{{ item.count_rejected }}</div>

      <div class="list-price-imports__table-cell list-price-imports__table-cell--reasons">
        <span *ngIf="!hasReasons(item) && !item.error">—</span>
        <span *ngFor="let reason of reasonLabels(item)" class="list-price-imports__reason">{{ reason }}</span>
        <span *ngIf="item.error" class="list-price-imports__reason list-price-imports__reason--error" [matTooltip]="item.error">
          {{ "knowledge_base.price_observations.imports.error" | translate }}
        </span>
      </div>
    </div>

    <div *ngIf="rows.length === 0" class="list-price-imports__empty">
      <img class="list-price-imports__empty-illustration" src="assets/icones/no-result-search.svg" alt="" />
      <h3>{{ "knowledge_base.price_observations.imports.empty_state" | translate }}</h3>
    </div>
  </div>
</div>

<app-pagination *ngIf="rows.length > 0" [pagination]="metadata$ | async" (toPageEvent)="toPage($event)"> </app-pagination>
